<template>
  <div class="center">
    <div class="flex_p">
      <p><span>考生姓名：</span>{{ operationObj.RealName }}</p>
      <p><span>考生账号：</span>{{ operationObj.UserName }}</p>
      <p><span>科室：</span>{{ operationObj.DepartmentName }}</p>
      <p><span>职称：</span>{{ operationObj.PTitle }}</p>
    </div>
    <!-- 主体部分 -->
    <main>
      <div class="main_view">
        <p>{{ operationObj.ScoreTitle }}</p>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="操作项目：" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入操作项目"
              :disabled="state == 2"
            ></el-input>
          </el-form-item>
          <el-form-item label="考核完成时间：" prop="time">
            <el-date-picker
              v-model="ruleForm.time"
              type="datetime"
              placeholder="选择日期时间"
              :disabled="state == 2"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <!-- 表格 -->
        <el-table
          v-if="Level == 1"
          :data="tableData"
          stripe
          ref="table"
          style="width: 100%"
          :summary-method="getSummaries"
          show-summary
          :header-cell-style="{
            'background-color': '#EEEEEE',
            color: '#333333',
            height: '60px',
          }"
        >
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="项目" width="180">
          </el-table-column>
          <el-table-column prop="projectScore" label="项目分" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.buckleType == 1 || !scope.row.buckleType">
                {{ scope.row.projectScore }}
              </div>
              <p
                v-else-if="scope.row.buckleType && scope.row.buckleType == 2"
                class="red1 text_left"
              >
                (扣分项)
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="score" label="得分">
            <!-- 11.22产品更改默认满分 -->
            <template slot-scope="scope">
              <el-input-number
                v-if="scope.row.buckleType == 1 || !scope.row.buckleType"
                v-model.trim="scope.row.score"
                :step="0.5"
                :min="total == 0 ? scope.row.score : 0"
                :max="Number(scope.row.projectScore)"
                @input="checkScore(scope.row.score, scope.row, scope.$index)"
                :disabled="state == 2"
              ></el-input-number>
               <!-- 扣分项 这个就是那个input 你先填写-10 加一下不就是-9，我知道了。要看翔哥的逻辑吗？ 不看-->
              <el-input-number
                v-else-if="scope.row.buckleType && scope.row.buckleType == 2"
                v-model="scope.row.score"
                :step="0.5"
                :disabled="state == 2"
                @change="changeNum(scope.row.score, scope.$index)"
              ></el-input-number>
              <p
                v-else-if="scope.row.buckleType && scope.row.buckleType == 2"
                class="red1 text_left"
              >
                注：此项为负分项
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="扣分细节" width="300">
            <template slot-scope="scope">
              <el-input
                class="input_two"
                v-model.trim="scope.row.scoreTxte"
                :disabled="state == 2"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
        <Second ref="second" v-else-if="Level == 2" :tableData="tableData" />
        <Tertiary
          ref="tertiary"
          v-else-if="Level == 3"
          :tableData="tableData"
        />
        <div class="passScore_view">
          <p>及格分：</p>
          <el-input v-model="passScore" disabled></el-input>
        </div>
        <div class="button_">
          <el-button
            type="primary"
            :loading="sundflag"
            @click="submitForm('ruleForm')"
            >{{ buttonText }}</el-button
          >
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import assessApi from "@/api/assessment";
import Second from "./Second.vue";
import Tertiary from "./Tertiary.vue";
import loginvuex from "@/store/index";

export default {
  data() {
    return {
      buttonText: "保存",
      total: "", // 得分
      totals: 0,
      Scores: "", // 及格分
      passScore: "", // 及格分
      sundflag: false, // 防抖
      ruleForm: {
        name: "护理人员技术考核表", // 操作项目名称 11.6
        time: "", // 结束时间
      },
      timer: null, // 保存定时器
      tableData: [],
      rules: {
        name: [
          { required: true, message: "请输入操作项目名称", trigger: "blur" },
        ],
        time: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
    };
  },
  props: ["state", "operationObj", "studentID", "text", "Level"],
  updated() {
    if (this.Level == 1) {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.buttonText == "保存") {
            // 提交
            this.setSaveData();
          } else if (this.buttonText == "导出考核表") {
            // 导出
            this.exportAssessment();
          } else if (this.buttonText == "发布成绩") {
            // 发布成绩
            this.releaseExam();
          }
        } else {
          this.$message({
            message: "警告，当前还有信息未填写！",
            type: "warning",
          });
          return false;
        }
      });
    },
    // 保存
    async setSaveData() {
      this.tableData.forEach((item) => {
        if (item.score == "" || item.score == undefined) {
          item.score = 0;
        }
      });
      if (this.Level == 2) {
        this.total = this.$refs.second.total;
        this.tableData = this.$refs.second.tableData;
        this.Scores = this.$refs.second.Scores;
      } else if (this.Level == 3) {
        this.total = this.$refs.tertiary.total;
        this.tableData = this.$refs.tertiary.tableData;
        this.Scores = this.$refs.tertiary.Scores;
      }
      // 如果为评分的情况默认为0提交
      // if (this.passScore > this.Scores || this.passScore == "") {
      //   console.log(this.passScore);
      //   console.log(this.Scores, this.$refs.tertiary.Scores);
      //   this.$message({
      //     message: "警告，请添加及格分,当前及格分不能大于合计项目分",
      //     type: "warning",
      //   });
      // } else {
      // let listArr = this.tableData.map((item) => {
      //   return {
      //     name: item.name,
      //     projectScore: item.projectScore,
      //     score: item.score,
      //     scoreTxte: item.scoreTxte,
      //   };
      // });
      let newarr = [
        {
          info: {
            ScoreTitle: this.operationObj.ScoreTitle, // 操作评分表名称
            item: this.ruleForm.name, // 项目名称
            createTime: this.ruleForm.time, // 评分时间
            passScore: this.passScore, // 及格分
          },
          list: this.tableData, // 此处不传及格分
        },
      ];
      let obj = {
        studentID: this.studentID,
        examineID: this.$route.query.ID,
        contentTxt: JSON.stringify(newarr),
        score: this.total, // 总成绩
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      this.sundflag = true;
      const { data } = await assessApi.saveScore(obj);
      if (data.Status == 200) {
        this.$message({
          message: "恭喜你，保存成功",
          type: "success",
        });
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        this.$parent.state = 0;
        this.$parent.getDatalist();
      } else {
        this.sundflag = false;
        this.$message.error(data.Msg);
      }
      // }
    },
    // 导出考核表
    exportAssessment() {
      let obj = {
        studentID: this.studentID,
        examineID: this.$route.query.ID,
        type: 0,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      this.sundflag = true;
      assessApi.word_down(obj).then((res) => {
        if (res.data.Status == 200) {
          let link = document.createElement("a");
          // let url = `${process.env.VUE_APP_EXPORTURL}${res.data.Data}`;
          let url = res.data.Data;
          link.setAttribute("target", "_blank");
          link.href = url;
          link.click();
          this.$message({
            message: `恭喜你，导出考核表成功`,
            type: "success",
          });
          setTimeout(() => {
            this.sundflag = false;
          }, 500);
        } else {
          this.sundflag = false;
          this.$message.error(data.message);
        }
      });
    },
    // 发布成绩
    async releaseExam() {
      let obj = {
        examineID: this.$route.query.ID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      this.sundflag = true;
      const { data } = await assessApi.exportPublish(obj);
      if (data.Status == 200) {
        this.$message({
          message: `恭喜你，发布成绩成功`,
          type: "success",
        });
        this.$parent.state = 0;
        this.$parent.getDatalist();
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
      } else {
        this.sundflag = false;
        this.$message.error(data.Msg);
      }
    },
    // 判断当前是否数字
    checkScore(row, obj, index) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (isNaN(row) == true) {
          this.$message({
            message: "警告，分数必须是数字",
            type: "warning",
          });
          console.log("执行了这里情况");
          this.tableData[index].score = ""; // 清除当前输入框分数
        }
        if (row > Number(obj.projectScore)) {
          this.$message({
            message: "警告，当前得分不能超过当前项目分",
            type: "warning",
          });
          // 默认将当前分数为项目分
          this.tableData[index].score = this.tableData[index].projectScore;
        }
      }, 500);
    },
      changeNum(num, sindex) {
      //扣分计算
      if (num > 0) {
        this.$nextTick(() => {
          this.tableData[sindex].score = -num;
          this.changeNum(-num, sindex);
        });
        return;
      }
      let afterDya = JSON.parse(JSON.stringify(this.tableData));
      afterDya.splice(sindex, 1);
      console.log(afterDya, " afterDya");
      let targetNUm = afterDya.reduce((first, scend) => {
        return first + Number(scend.score);
      }, 0);
      let disabledNum = -targetNUm;
      console.log(targetNUm, "targetNUm");
      if (num <= disabledNum) {
        this.$nextTick(() => {
          this.tableData[sindex].score = disabledNum;
        });
        // console.log("after", this.tableData);
      }
    },
    //合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === "projectScore" || column.property === "score") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        }
      });
      this.Scores = sums[2]; // 总分
      this.total = sums[3]; // 得分
      this.totals = Number(JSON.parse(JSON.stringify(sums[3] || 0)));
      return sums;
    },
  },
  components: {
    Second,
    Tertiary,
  },
  created() {
    // this.tableData.map((item) => {
    //   this.$set(item, "score", Number(0)); // 得分
    //   this.$set(item, "scoreTxte", ""); // 扣分细节
    // });
    if (this.state == 2 && this.$parent.rowObj.row.IsPublish1 == "未发布") {
      this.buttonText = "发布成绩";
    } else if (
      this.state == 2 &&
      this.$parent.rowObj.row.IsPublish1 == "已发布"
    ) {
      this.buttonText = "导出考核表";
    } else {
      this.buttonText = "保存";
    }
    // this.ruleForm.time = this.$moment().format("YYYY-MM-DD HH:mm:ss");
    // setTimeout(()=>{
    // console.log(this.passScore,'---------->>',this.operationObj);
    // },2000)
  },
};
</script>

<style lang="scss" scoped>
.center {
  margin-top: 24px;
  border-top: 1px solid #dbdee2;
  padding: 38px;
}
.flex_p {
  display: flex;
  align-items: center;
  p {
    margin-right: 60px;
    span {
      font-weight: 600;
    }
  }
}
.button_ {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 38px;
}
.input_two {
  width: 279px;
  background: #ffffff;
}
.input_one {
  width: 71px;
  background: #ffffff;
}
main {
  margin-top: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  .main_view {
    min-width: 966px;
    min-height: 540px;
    p {
      text-align: center;
      font-size: 30px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #333333;
      line-height: 78px;
    }
    ::v-deep .el-form {
      display: flex;
      justify-content: space-between;
      padding: 0 30px;
      margin-top: 20px;
    }
  }
  ::v-deep .el-form-item__label {
    text-align: left;
  }
  ::v-deep .el-form-item:nth-child(1) {
    margin-right: 36px;
    .el-form-item__label {
      width: 100px !important;
    }
    .el-form-item__content {
      margin-left: 100px !important;
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
::v-deep .el-table__cell {
  text-align: center;
}
.cell {
  text-align: center;
}
.red {
  border: 1px solid red;
  border-radius: 4px;
  &:focus {
    border-color: red !important;
  }
}
.red1 {
  color: red !important;
}
.text_left {
  text-align: center !important;
  font-size: 14px !important;
  line-height: 22px !important;
}
.passScore_view {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  > p {
    width: 100px;
    font-size: 22px !important;
  }
  ::v-deep .el-input__inner {
    width: 100px;
  }
}
.el-table__body-wrapper {
  padding-bottom: 38px !important;
}
.el-table__footer-wrapper {
  margin-top: -38px;
}
// ::v-deep .el-radio__inner {
//   border: 1px solid #000 !important;
// }
</style>
